module.exports = __webpack_public_path__ + "logo_rvcnn_rovcanin_jewellery_design_handmade.png?8e4b10de1e15e20ab05491a544f5d33f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/logo_rvcnn_rovcanin_jewellery_design_handmade.png
// module id = 95
// module chunks = 0